import { createEffect, createEvent, createStore } from 'effector'
import api from '../../Auth/api'
import { TErrorResponse, TResponse } from '../types'
import { $mainTable } from './search'

type TMarkPaidServiceAsUnreadResponse = TResponse<{ success: boolean }>

/** Отметить платную услугу как непрочитанную ("мои в работе") */
export const markPaidServiceAsUnreadFx = createEffect<
  { paidServiceId: number },
  TMarkPaidServiceAsUnreadResponse,
  TErrorResponse
>((data) => api.post('in-work/unread', data))

export const setMarkingUnreadPaidServiceId = createEvent<number | null>()

export const $markingUnreadPaidServiceId = createStore<number | null>(null).on(
  setMarkingUnreadPaidServiceId,
  (_, id) => id
)

markPaidServiceAsUnreadFx.watch(({ paidServiceId }) => {
  setMarkingUnreadPaidServiceId(paidServiceId)
})

markPaidServiceAsUnreadFx.finally.watch(() => {
  setMarkingUnreadPaidServiceId(null)
})

// После маркировки сразу показываем шарик в списке, без повторного запроса
;($mainTable as any).on(
  markPaidServiceAsUnreadFx.done,
  (state: any, { params }: { params: { paidServiceId: number } }) => {
    const rows = state?.data?.rows
    if (!rows) {
      return state
    }

    return {
      ...state,
      data: {
        ...state.data,
        rows: rows.map((row: any) =>
          row.id === params.paidServiceId ? { ...row, isViewed: false } : row
        )
      }
    }
  }
)
